import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getFileList(listId: number) {
    let promise = new Promise ((resolve, reject) => {
      this.http.get(`${this.baseUrl}api/FileUpload/GetListOfFilesByListId/${listId}`, {observe: 'response'})
        .toPromise()
        .then(response => resolve(response));
    });
    return promise;
  }

  getFileNameById(fileUploadId: number) {
    return this.http.get(`${this.baseUrl}api/FileUpload/GetFileNameById/${fileUploadId}`, { responseType: 'text' });
  }

  downloadFile(fileUploadId: number) {
    let promise = new Promise ((resolve, reject) => {
      this.http.get(`${this.baseUrl}api/FileUpload/Download/${fileUploadId}`, { responseType: 'blob'})
        .toPromise()
        .then(
          (response: Blob) => {
            resolve(response);
          },
          (error: Object) => {
            reject();
          }
      );
    });
    return promise;
  }

  postFiles(files: FileList, appropriatorId: number, listId = '') {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      Array.prototype.forEach.call(files, file =>
        formData.append('files', file)
      )
      formData.append('appropriatorId', appropriatorId.toString());

      this.http.post(`${this.baseUrl}api/FileUpload/UploadToList/${listId}`, formData, { observe: 'response' })
        .toPromise()
        .then(response => resolve(response));
    });
  }

  deleteFile(fileUploadId: number) {
    let promise = new Promise ((resolve, reject) => {
      this.http.delete(`${this.baseUrl}api/FileUpload/Delete/${fileUploadId}`, {observe: 'response'})
        .toPromise()
        .then(response => resolve(response));
    });
    return promise;
  }

}

export interface FileUpload {
  fileUploadId: number,
  fileTypeId: number,
  fileName: string,
  fileSystemPath: string,
  createdByUserId: string,
  createdByUserName: string,
  createdDateTime: Date,
  fileSizeBits: number,
  fileUploadListId: number
}

export interface FileName {
  fileName: string
}
